/** Shared rules for when the chat composer must stay disabled (subscription, onboarding). */

import type { SubscriptionData } from "@/helpers/subscription.helper";

/** True when subscription state blocks sending messages (mirrors SubscriptionProvider). */
export function isSubscriptionComposerDisabled(
  subscriptionData?: SubscriptionData,
): boolean {
  if (!subscriptionData) {
    return false;
  }
  return (
    (!subscriptionData.remainingDays && !!subscriptionData.nextBillingDate) ||
    subscriptionData.status === "CREDITS_LIMIT_REACHED" ||
    subscriptionData.status === "TRIAL_ENDED" ||
    subscriptionData.status === "ENTERPRISE_CANCELLED"
  );
}
